<template functional>
  <!-- ユーザーに操作内容を確認するときに使うダイアログ。
  「戻る」ボタンと「（指定したテキスト）」ボタンを持つ -->
  <v-dialog
    :value="props.value"
    max-width="500"
    @input="listeners.input"
  >
    <v-card class="dialogCard">
      <v-card-text style="position: relative;">
        <slot />
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="props.loading"
          color="grey lighten-2"
          light
          @click="listeners.cancel"
        >
          戻る
        </v-btn>
        <v-btn
          :color="props.confirmBtnColor"
          :loading="props.loading"
          :disabled="props.disabled || props.loading"
          class="confirm-text"
          @click="listeners.confirm"
        >
          {{ props.confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    confirmText: {
      type: String,
      default: () => '削除'
    },
    confirmBtnColor: {
      type: String,
      default: () => 'red darken-1'
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  }
}
</script>

<style lang="scss" scoped>
.dialogCard{
  padding: 10px 5px;
  border: 3px solid var(--metal-blue);
  border-radius: 6px
}
.confirm-text {
  color: #fff;
  font-weight: bold !important;
}
</style>
